import { render } from "./SiteMapView.vue?vue&type=template&id=248787c9"
import script from "./SiteMapView.vue?vue&type=script&lang=js"
export * from "./SiteMapView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__